import {getUrlParam} from "./url";
import {utils} from "./index";

export function saveUtmToCookie() {
	if (getUrlParam("utm_source") != null && getUrlParam("utm_source") != "") {
		if (getUrlParam("utm_source") != utils.getCookie("utm_source")) {
			utils.setCookie("utm_source", getUrlParam("utm_source"), {
				path: "/",
				//domain: window.domain
			});
			utils.setCookie("utm_campaign", getUrlParam("utm_campaign"), {
				path: "/",
				//domain: window.domain
			});
			utils.setCookie("utm_medium", getUrlParam("utm_medium"), {
				path: "/",
				//domain: window.domain
			});
			utils.setCookie("utm_term", getUrlParam("utm_term"), {
				path: "/",
				//domain: window.domain
			});
			utils.setCookie("utm_content", getUrlParam("utm_content"), {
				path: "/",
				//domain: window.domain
			});
		}
	}
}
